import { t } from 'i18next'

import { formatDateToString, formatMoney } from '~/helpers'
import type { WalletBalanceOriginRow } from '~/modules/retailMedia/components/WalletBalanceOrigin/types'
import {
  labelCreditTypes,
  labelSubtypes,
  labelTypes
} from '~/modules/retailMedia/store/common/constants'

import { buildOriginSchemaColumn } from '../getTransactionOriginLabel'
import * as S from '../styles'

type SchemaArgs = {
  originById: Map<string, WalletBalanceOriginRow>
  showOriginColumn?: boolean
}

export const schema = ({
  originById,
  showOriginColumn = true
}: SchemaArgs): TableSchema<CheckingAccountTransaction> => ({
  date: {
    title: t('rm:wallet.movimentations.table.column.title.date'),
    render: rowData => (
      <small className="text-nowrap">
        {formatDateToString(rowData?.created_at)}
      </small>
    )
  },
  ...(showOriginColumn ? buildOriginSchemaColumn(originById) : {}),
  value: {
    title: t('rm:wallet.movimentations.table.column.title.value'),
    render: rowData => (
      <S.ValueTransaction transactionType={rowData?.transaction_type}>
        <strong className="amount text-nowrap">
          {formatMoney(rowData?.amount, false, 'R$ 0,00')}
        </strong>
      </S.ValueTransaction>
    )
  },
  type: {
    title: t('rm:wallet.movimentations.table.column.title.type'),
    render: rowData => {
      const creditType = rowData?.credit_type
      const transactionType = rowData?.transaction_type
      const transactionSubtype = rowData?.transaction_subtype

      const label = labelTypes?.[transactionType] || transactionType

      const hasCreditTypeDetail =
        transactionType === 'credit' && creditType != null
      const creditTypeDetail = labelCreditTypes?.[creditType] ?? ''
      const subtypeDetail =
        labelSubtypes?.[transactionType]?.[transactionSubtype]

      const detail = hasCreditTypeDetail ? creditTypeDetail : subtypeDetail

      return (
        <S.ColumnMainAndDetail className="lh-1">
          <span className="mainInfo">{label}</span>{' '}
          <small className="detail">{detail}</small>
        </S.ColumnMainAndDetail>
      )
    }
  },
  user: {
    title: t('rm:wallet.movimentations.table.column.title.user'),
    render: rowData => (
      <S.ColumnMainAndDetail className="lh-1">
        <span className="mainInfo">{rowData?.user_name}</span>{' '}
        <small className="detail">{rowData?.user_email}</small>
      </S.ColumnMainAndDetail>
    )
  },
  nota: {
    title: t('rm:wallet.movimentations.table.column.title.note'),
    render: rowData => (
      <S.Note>
        <span>{rowData?.note}</span>
      </S.Note>
    )
  }
})
